// extracted by mini-css-extract-plugin
export default {"modalBody":"disable-status-modal_modalBody__7rott","applyButton":"disable-status-modal_applyButton__3QyDG"};